// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VXzDP5rG89BqScH\\+ndB6Tg\\=\\={display:block;height:100vh;overflow:hidden;display:flex;flex-direction:column}", "",{"version":3,"sources":["webpack://./src/App.module.scss"],"names":[],"mappings":"AAAA,6BACE,aAAA,CACA,YAAA,CACA,eAAA,CACA,YAAA,CACA,qBAAA","sourcesContent":[".root {\n  display: block;\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "VXzDP5rG89BqScH+ndB6Tg=="
};
export default ___CSS_LOADER_EXPORT___;
